import { isAuthPagePath } from './authPagePaths.js';

const sidebarHiddenPathPatterns = [
  /^\/campaign-hub$/,
  /^\/campaigns\/\d+/,
  /\/user\/campaigns\//,
  /^\/campaigns\/learn$/,
  /^\/user\/chats$/,
  /^\/about(\/.*)?$/,
  /^\/community-guidelines$/,
  /^\/jobs$/,
];

export function isSidebarHiddenPath(pathname) {
  return sidebarHiddenPathPatterns.some((pattern) => pattern.test(pathname)) || isAuthPagePath(pathname);
}

export function shouldShowSidebarMenu(pathname) {
  return !isSidebarHiddenPath(pathname);
}
